import { styled } from '@mui/system'

export const CardHeader = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`

export const DetailsGrid = styled('section')`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    @media (min-width: 1280px) {
        grid-template-columns: 1fr 2fr;
    }
`

export const DetailsColumn = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const EditButton = styled('div')`
    cursor: pointer;
    display: inline-flex;
`
